import $ from "jquery";

$(function () {
	// $('.flip-box, .flip-box__button').on('click', function () {
	//     $(this).toggleClass('flip');
	// });
	$(".Flipbox").hover(
		function () {
			$(this).addClass("flip");
		},
		function () {
			$(this).removeClass("flip");
		}
	);

	// The IE fix should already be in the topfloor-parcel theme. I'm putting it here in case it's not.
	// ie fix, adds class to html doc so we can style stuff differently for ie
	// if (document.documentMode === 10 || document.documentMode === 11) {
	//     $('html').addClass('ie');
	// }
});
